<mat-card appearance="outlined" class="transport-order-dates">
  <mat-card-title class="tw-flex tw-items-center">
    <ui-svg-icon
      *ngIf="isDefaultTitleIconVisible"
      [name]="iconNameList.History"
      [width]="32"
      class="transport-order-dates__icon"
    ></ui-svg-icon>
    <ng-content></ng-content>
  </mat-card-title>
  <mat-card-content [dataSource]="statuses" noDataTableMessage>
    <table *ngIf="statuses?.length">
      <tr>
        <th class="transaction-time">
          <div class="tw-flex tw-items-center tw-gap-2 tw-justify-end">
            <ui-svg-icon [name]="iconNameList.Clock" class="transport-order-dates__icon"></ui-svg-icon>
            <span cropText>{{ 'transportOrder.overview.receivedAt' | translate }}</span>
          </div>
        </th>
        <th class="status-info">
          <span cropText>
            {{ 'common.field.statusCode' | translate }}
          </span>
        </th>
        <th>
          <div class="tw-flex tw-items-center tw-gap-2">
            <ui-svg-icon [name]="iconNameList.CalendarClock" class="transport-order-dates__icon"></ui-svg-icon>
            <span cropText>
              {{ (columnTitles && columnTitles[0]) || 'transportOrder.dates.rowTitle.estimatedTime' | translate }}
            </span>
          </div>
        </th>
        <th>
          <div class="tw-flex tw-items-center tw-gap-2">
            <ui-svg-icon [name]="iconNameList.Agility" class="transport-order-dates__icon"></ui-svg-icon>
            <span cropText>
              {{ (columnTitles && columnTitles[1]) || 'transportOrder.dates.rowTitle.actualTime' | translate }}
            </span>
          </div>
        </th>
      </tr>
      <tbody>
        <tr *ngFor="let statusItem of statuses" class="status-item">
          <td class="transaction-time">
            <ng-container
              *ngTemplateOutlet="localDateTemplate; context: { localDate: statusItem?.transactionDateTime }"
            ></ng-container>
          </td>
          <td class="status-info">
            <ui-status-code
              [statusCode]="statusItem?.statusCode"
              [statusDescription]="statusItem?.statusCodeDescription"
              class="status-info__code"
            ></ui-status-code>
            <ui-tooltip-alert
              *ngIf="statusItem?.latestNotification?.reason"
              [tooltipText]="statusItem?.latestNotification?.reason"
              class="status-info__icon"
            ></ui-tooltip-alert>
          </td>
          <td [class.status-info__date-with-icon]="statusItem?.statusDateTime && !statusItem?.statusDateTime?.resolved">
            <ng-container
              *ngIf="
                statusItem.acceptanceType && statusItem.acceptanceType === statusAcceptanceType.NotReceived;
                else plannedDepartureTime
              "
            >
              <ng-container
                *ngTemplateOutlet="localDateTemplate; context: { localDate: statusItem?.statusDateTime }"
              ></ng-container>
            </ng-container>

            <ng-template #plannedDepartureTime>
              <ng-container
                *ngTemplateOutlet="localDateTemplate; context: { localDate: statusItem?.plannedDepartureTime }"
              ></ng-container>
            </ng-template>
          </td>
          <td [class.status-info__date-with-icon]="statusItem?.statusDateTime && !statusItem?.statusDateTime?.resolved">
            <ng-container
              *ngIf="
                statusItem.acceptanceType && statusItem.acceptanceType === statusAcceptanceType.Received;
                else plannedArrivalTime
              "
            >
              <ng-container
                *ngTemplateOutlet="localDateTemplate; context: { localDate: statusItem?.statusDateTime }"
              ></ng-container>
            </ng-container>

            <ng-template #plannedArrivalTime>
              <ng-container
                *ngTemplateOutlet="localDateTemplate; context: { localDate: statusItem?.plannedArrivalTime }"
              ></ng-container>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
</mat-card>

<ng-template #localDateTemplate let-localDate="localDate">
  <ui-date-with-timezone
    class="cropped"
    [localDate]="localDate"
    [isEmptyStringAvailable]="true"
  ></ui-date-with-timezone>
</ng-template>
